export default {
    tryParse: (value) => {
        try {
            let json = JSON.parse(value);
            if (!json.__SecurionPayV2) {
                return null;
            }

            return json;
        } catch (e) {
            return null;
        }
    },

    stringify: (value) => {
        return JSON.stringify({...value, __SecurionPayV2: true});
    }
}